// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3CoIZ","title":"AfterFrontImage_title__3HY6Q"};